// fonction.js

import { formatTimeToDate } from "../general/formateDate";
import rest from "../../rest";

// Fonction pour regrouper les messages par date
export const groupMessagesByDate = (messages) => {
  return messages.reduce(
    (accumulator, currentMessage) => {
      const lastGroup = accumulator[accumulator.length - 1];
      const latestMessageInLastGroup = lastGroup[lastGroup.length - 1];

      if (
        latestMessageInLastGroup &&
        formatTimeToDate(latestMessageInLastGroup.MessageDate, "small") !==
        formatTimeToDate(currentMessage.MessageDate, "small")
      ) {
        accumulator.push([currentMessage]);
      } else {
        lastGroup.push(currentMessage);
      }

      return accumulator;
    },
    [[]]
  );
};

// Fonction pour récupérer les données de chat
export const fetchChatData = async (
  setMessages,
  setFilteredMessages,
  setGroupedMessages,
  setUsers,
  setSelectedUser,
  currentUser,
  messages,
  selectedUser,
  setLoadingMessages,
  setMessageHistory,
  setUsersHistory
) => {
  let sender,
    messagesXlr,
    selectUser = selectedUser;
  try {
    // Récupérer les messages
    const messagesResponse = await rest.get(
      "/benevols/chat/listeMessages.json"
    );
    messagesXlr = messagesResponse.data.messages;
  

    // Récupérer les utilisateurs
    const users = await fetchUsers();
    
    
    // Mettre à jour les utilisateurs avec le nombre de messages non lus
    const userUpdate = users.map((user) => {
      const notRead = messagesXlr?.filter(
        (msg) => msg.Sender_Person.ID === user.ID && !msg.Read
      );
      return { ...user, nbNotRead: notRead.length };
    });
    
    setUsers(userUpdate);

    // Créer un set pour les messages provenant d'utilisateurs non présents dans la liste pour liste history
    const nonUserMessages = new Set();
    const nonUserListMap = new Map();

    // Parcourir les messages pour identifier ceux venant de non-utilisateurs
    messagesXlr.forEach((msg) => {
      // Identifier l'autre personne dans la conversation (expéditeur ou destinataire)
      const otherPerson = msg.Sender_Person.ID === currentUser.User.User_Person_ID ? msg.Reciver_Person : msg.Sender_Person;

      // Vérifier si cette autre personne n'est pas dans la liste des utilisateurs connus
      const isUserInList = userUpdate.some(
        (user) => user.ID === otherPerson.ID
      );

      // Si l'autre personne n'est pas dans la liste des utilisateurs connus
      if (!isUserInList) {
        nonUserMessages.add(msg);
        nonUserListMap.set(otherPerson.ID, otherPerson);
      }
    });

    // Ajouter les messages de non-utilisateurs à l'historique
    if (nonUserMessages.size > 0) {
      setMessageHistory(Array.from(nonUserMessages));
      setUsersHistory(Array.from(nonUserListMap.values()));
    }

    if (messages.length !== messagesXlr.length) {
      // Si des messages ont été ajoutés
      // Trouver un message non lu qui ne provient pas de l'utilisateur actuel et dont l'expéditeur ou le destinataire est dans la liste des utilisateurs
      sender = messagesXlr?.find((row) => {
        const otherPerson = row.Sender_Person.ID === currentUser.User.User_Person_ID ? row.Reciver_Person : row.Sender_Person;
        const isUserInList = userUpdate.some(
          (user) => user.ID === otherPerson.ID
        );
        return (
          !row.Read && userUpdate.some((user) => user.ID === otherPerson.ID && isUserInList)
        );
      });
      

      if (!sender) {
        // Si aucun message non lu n'est trouvé, trouver le message le plus récent d'un utilisateur dans la liste
        sender = messagesXlr?.reduce((latest, row) => {
          const otherPerson = row.Sender_Person.ID === currentUser.User.User_Person_ID ? row.Reciver_Person : row.Sender_Person;const isUserInList = userUpdate.some(
            (user) => user.ID === otherPerson.ID
          );
          if (otherPerson.ID !== currentUser.User.User_Person_ID && userUpdate.some((user) => user.ID === otherPerson.ID && isUserInList)) {
            return !latest || row.MessageDate > latest.MessageDate ? row : latest;
          }
          return latest;
        }, null);
      }

      if (sender) {
        const otherPerson = sender.Sender_Person.ID === currentUser.User.User_Person_ID ? sender.Reciver_Person : sender.Sender_Person;
        selectUser = otherPerson.ID;
      } else if (!selectUser) {
        // Si pas de message non lu ni de dernier message trouvé, choisir le premier utilisateur de la liste
        selectUser = userUpdate[0]?.ID;
      }

      setSelectedUser(selectUser);

      setMessages(messagesXlr);

      const messageFrom = messagesXlr?.filter(
        (msg) => msg.Sender_Person?.ID === selectUser ||  msg.Reciver_Person?.ID === selectUser
      );

      setFilteredMessages(messageFrom);
      setGroupedMessages(groupMessagesByDate(messageFrom));
    }
  } catch (error) {
    console.error("Error fetching messages", error);
  } finally {
    setLoadingMessages(false); // Marque le chargement des messages comme terminé
  }
};

export const fetchUsers = async () => {
  try {
    // Récupérer les utilisateurs
    const usersResponse = await rest.get("/benevols/chat/listeUsers.json");
    return usersResponse.data.users;
  } catch (error) {
    console.error("Error fetching users", error);
    throw error; // Propager l'erreur pour que `fetchChatData` puisse la gérer
  }
};
